module.exports = function(h, row) {
    return row.sold;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/couponredeem/sold.jsx